export default "__VITE_ASSET__911060ca__"